import styled from 'styled-components';

interface Props {
    $selected?: boolean;
    $disabled?: boolean;
}

export const SelectableWrapper = styled.div<Props>`
    width: 100%;
    position: relative;
    cursor: ${({ $disabled }) => ($disabled ? 'initial' : 'pointer')};
    transition: opacity ${({ theme }) => theme.transitions.speeds.normal}s;

    &:before {
        content: '';
        background: ${({ theme }) => theme.colors.purple};
        position: absolute;
        top: -12px;
        right: -12px;
        bottom: -12px;
        left: -12px;
        border-radius: 10px;
        opacity: ${({ $selected }) => ($selected ? 1 : 0)};
        transition: opacity ${({ theme }) => theme.transitions.speeds.normal}s;
        pointer-events: none;
        z-index: -1;
    }
`;
